import React, { useEffect, useState } from "react";

import classnames from "classnames";

import dsdesExploreApi from "apis/dsdesExplore";
import referenceSourceApi from "apis/reference_sources";
import { Button, Pane, Typography, Table } from "clearsense-ui/components";

import { SELECT_REFERENCE_SOURCE_COLUMN } from "../../constants/selectReferenceSource";

const SelectReferenceSource = ({
  isPaneOpen,
  setIsPaneOpen,
  dsde,
  fetchAssociatedReferenceSource,
}) => {
  const [selected, setSelected] = useState(-1);
  const [referenceSources, setReferenceSources] = useState([]);

  const fetchReferenceSources = async () => {
    try {
      const { data } = await referenceSourceApi.index();
      setReferenceSources(data?.reference_sources);
    } catch (error) {
      logger.log(error);
    }
  };

  useEffect(() => {
    fetchReferenceSources();
  }, []);

  const handleSave = async () => {
    try {
      if (selected > -1) {
        await dsdesExploreApi.associateReferenceSources(
          dsde.id,
          referenceSources[selected]
        );
        fetchAssociatedReferenceSource();
      }
    } catch (error) {
      logger.log(error);
    } finally {
      setIsPaneOpen(false);
    }
  };

  return (
    <Pane isOpen={isPaneOpen} onClose={() => setIsPaneOpen(false)}>
      <Pane.Header>
        <Typography style="h3" type="bold" className="-mt-3">
          Select a Reference Source
        </Typography>
        <Typography style="large">
          Select an existing reference source to associate to the DSDE
        </Typography>
      </Pane.Header>
      <Pane.Body className="py-8">
        <Table
          rowClassName={(_, index) =>
            classnames("capitalize", {
              "bg-gray-100 text-indigo-600 font-bold": index === selected,
            })
          }
          columnData={SELECT_REFERENCE_SOURCE_COLUMN}
          rowData={referenceSources}
          allowRowClick
          onRowClick={(_, __, rowIndex) => setSelected(rowIndex)}
        />
      </Pane.Body>
      <Pane.Footer className="gap-4">
        <Button label="Save and Close" onClick={handleSave} />
        <Button
          label="Cancel"
          style="secondary"
          onClick={() => setIsPaneOpen(false)}
        />
      </Pane.Footer>
    </Pane>
  );
};

export default SelectReferenceSource;
